export const drawerItemsMain = [
  {
    key: "ProductTracker",
    title: "customerOrderTracker",
    routes: [
      {
        nav: "ProductTrackerReport",
        routeName: "ProductTrackerReport",
        title: "productTrackerReport",
      },
    ],
  },
  {
    key: "TrackerDashboard",
    title: "customerOrderDashboard",
    routes: [
      {
        nav: "TrackerDashboardReport",
        routeName: "TrackerDashboardReport",
        title: "trackerDashboardReport",
      },
    ],
  },
  {
    key: "ChinaTracker",
    title: "chinaTracker",
    routes: [
      {
        nav: "ChinaTrackerReport",
        routeName: "ChinaTrackerReport",
        title: "chinaTrackerReport",
      },
    ],
  },
  {
    key: "ChinaTrackerGantt",
    title: "chinaTrackerPlanning",
    routes: [
      {
        nav: "ChinaTrackerGanttReport",
        routeName: "ChinaTrackerGanttReport",
        title: "chinaTrackerPlanning",
      },
    ],
  },
  {
    key: "ChinaShipment",
    title: "chinaShipment",
    routes: [
      {
        nav: "ChinaShipmentReport",
        routeName: "ChinaShipmentReport",
        title: "chinaShipmentReport",
      },
    ],
  },
  {
    key: "GlobalShipment",
    title: "globalShipment",
    routes: [
      {
        nav: "GlobalShipmentReport",
        routeName: "GlobalShipmentReport",
        title: "globalShipmentReport",
      },
    ],
  },
];
